import { post, get, put, deleteApi } from './axiosFun';

// 菜单列表树 
export const menuList = () => { return post("/sys/sys-menu/menuList", {}) };
//菜单新增
export const menuAdd = (params) => { return post("/sys/sys-menu/menuAdd", params) };
//菜单编辑
export const menuEdit = (params) => { return post("/sys/sys-menu/menuEdit", params) };
//菜单删除
export const menuRemove = (params) => { return post("/sys/sys-menu/menuRemove", params) };



// WEBPACK FOOTER //
// ./src/api/menuMG.js